export interface TimelineEvent {
  id: number;
  date: string;
  stage: string;
  title: string;
  desc: string;
  tone: "start" | "rise" | "storm" | "answer";
}

export const timeline: TimelineEvent[] = [
  {
    id: 1,
    date: "走红初期",
    stage: "01 爆火",
    title: "以「敢说」人设被看见",
    desc: "哇偶姐姐凭借一段犀利吐槽视频走红，因「不装、敢说」迅速圈粉，被视为互联网嘴替，短视频与评论区热度持续攀升。",
    tone: "start",
  },
  {
    id: 2,
    date: "热度攀升期",
    stage: "02 破圈",
    title: "粉丝破圈，商务随之而来",
    desc: "随着粉丝量级上涨，哇偶姐姐开始出现在更多热搜与跨平台话题中，合作邀约增多，商业内容和曝光量同步放大。",
    tone: "rise",
  },
  {
    id: 3,
    date: "争议发酵",
    stage: "03 起风",
    title: "旧帖被扒，反差质疑出现",
    desc: "网友开始考古其早期发言与旧照，发现与其「耿直清醒」人设存在反差，多条热搜出现，质疑声音从评论区蔓延到各平台。",
    tone: "storm",
  },
  {
    id: 4,
    date: "风暴顶点",
    stage: "04 风暴",
    title: "直播回应与「翻白眼」出圈",
    desc: "哇偶姐姐开深夜直播回应，回放与片段被大量二次传播，「翻白眼」「怼黑粉」等名场面成为全网热梗，讨论度达到峰值。",
    tone: "storm",
  },
  {
    id: 5,
    date: "舆论分化",
    stage: "05 分化",
    title: "路人缘与真爱粉明显分化",
    desc: "舆论分裂为「黑到底」「围观吃瓜」「理性支持」三派。群嘲与理性分析并存，评论区画风从单一吐槽走向多角度的观点交锋。",
    tone: "answer",
  },
  {
    id: 6,
    date: "当前",
    stage: "06 观察",
    title: "热度回落，等待后续走向",
    desc: "热搜热度逐渐回落，但考古与复盘内容仍在持续产出。哇偶姐姐后续的处理方式，将决定这次风波的最终走向。",
    tone: "answer",
  },
];